<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-progress-linear
        indeterminate
        :active="isRequestingNow.length > 0"
        color="blue"
        class="mb-0"
      ></v-progress-linear>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-layout>
    <v-flex v-if="item" style="position: relative">
      <v-container class="grey lighten-5">
        <v-row>
          <v-col cols="12" sm="4" class="py-md-0">
            <v-text-field
              v-model="item.name"
              :counter="200"
              :rules="[rules.required, rules.max(200)]"
              :label="lang($store, 'sap/listings.global.filter.hints.name')"
              prepend-icon="mdi-account-badge-outline"
              required
              autocomplete="off"
              :error-messages="errors && errors.name ? errors.name : null"
              @change="updateRequest('name', $event)"
              @input="removeError('name')"
              :loading="isRequestingNow.includes('name')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" class="py-md-0">
            <field-phone-with-note
              v-model="item.phone"
              :value-note="item.phone_note"
              :rules="[rules.required, rules[initPhoneRule]]"
              :rules-note="[rules.max(50)]"
              :counter="50"
              :error-message="errors && errors.phone ? errors.phone : null"
              :error-message-note="
                errors && errors.phone_note ? errors.phone_note : null
              "
              @change="updateRequest('phone', $event)"
              @input="removeError('phone')"
              :loading="isRequestingNow.includes('phone')"
              @change-note="updateRequest('phone_note', $event)"
              @input-note="
                item.phone_note = $event;
                removeError('phone_note');
              "
              :loading-note="isRequestingNow.includes('phone_note')"
            ></field-phone-with-note>
          </v-col>
          <v-col cols="12" sm="4" class="py-md-0">
            <field-phone-with-note
              v-model="item.phone2"
              :value-note="item.phone2_note"
              :rules="[rules[initPhoneRule]]"
              :rules-note="[rules.max(50)]"
              :counter="50"
              :label="lang($store, 'sap/listings.global.filter.hints.phone2')"
              :error-message="errors && errors.phone2 ? errors.phone2 : null"
              :error-message-note="
                errors && errors.phone2_note ? errors.phone2_note : null
              "
              @change="updateRequest('phone2', $event)"
              @input="removeError('phone2')"
              :loading="isRequestingNow.includes('phone2')"
              @change-note="updateRequest('phone2_note', $event)"
              @input-note="
                item.phone2_note = $event;
                removeError('phone2_note');
              "
              :loading-note="isRequestingNow.includes('phone2_note')"
            ></field-phone-with-note>
          </v-col>
          <v-col cols="12" md="3">
            <v-select
              v-model="item.source"
              :items="sourcesItems"
              prepend-icon="mdi-arrow-decision-outline"
              single-line
              :hint="lang($store, 'sap/listings.global.filter.hints.source')"
              persistent-hint
              :error-messages="errors && errors.source ? errors.source : null"
              @change="
                removeError('source');
                updateRequest('source', $event);
              "
              :loading="isRequestingNow.includes('source')"
            ></v-select>
          </v-col>
          <v-col cols="12" md="9">
            <v-row class="pt-4">
              <v-col cols="12" md="3">
                <v-switch
                  v-model="item.bank_private"
                  class="my-0"
                  color="#8DC641"
                  :false-value="0"
                  :true-value="1"
                  @change="updateRequest('bank_private', $event)"
                  :label="lang(
                      $store,
                      'sap/listings.global.filter.hints.privatbank'
                    ) + '?'"
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-switch
                  v-model="item.use_ukrainian"
                  class="my-0"
                  :false-value="0"
                  :true-value="1"
                  @change="updateRequest('use_ukrainian', $event)"
                  :label="
                    lang(
                      $store,
                      'sap/listings.global.filter.hints.use_ukrainian'
                    )
                  "
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-switch
                  v-model="item.use_english"
                  class="my-0"
                  :false-value="0"
                  :true-value="1"
                  @change="updateRequest('use_english', $event)"
                  :label="
                    lang($store, 'sap/listings.global.filter.hints.use_english')
                  "
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-switch
                  v-model="item.is_viber"
                  class="my-0"
                  :false-value="0"
                  :true-value="1"
                  @change="updateRequest('is_viber', $event)"
                  :label="
                    lang($store, 'sap/listings.global.filter.hints.is_viber')
                  "
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-switch
                  v-model="item.black_listed"
                  class="my-0"
                  color="#000"
                  :false-value="0"
                  :true-value="1"
                  @change="updateRequest('black_listed', $event)"
                  :label="
                    lang(
                      $store,
                      'sap/listings.global.filter.hints.black_listed'
                    )
                  "
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="12">
            <v-row align="center">
              <v-col cols="12" md="8">
                <v-text-field
                  v-model="item.note"
                  :counter="200"
                  :rules="[rules.max(200)]"
                  prepend-icon="mdi-tooltip-text-outline"
                  :label="lang($store, 'sap/listings.global.filter.hints.note')"
                  autocomplete="off"
                  :error-messages="errors && errors.note ? errors.note : null"
                  @change="updateRequest('note', $event)"
                  @input="removeError('note')"
                  :loading="isRequestingNow.includes('note')"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="item.password"
                  :counter="50"
                  :rules="[rules.max(50), rules.min(6)]"
                  prepend-icon="mdi-lock-question"
                  :append-icon="
                    showPass ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
                  "
                  :type="showPass ? 'text' : 'password'"
                  @click:append="showPass = !showPass"
                  :label="
                    lang($store, 'sap/listings.global.filter.hints.password')
                  "
                  :hint="
                    lang(
                      $store,
                      'sap/listings.global.filter.hints.password_live_empty'
                    )
                  "
                  persistent-hint
                  autocomplete="new-password"
                  @change="changePassword"
                  :loading="isRequestingNow.includes('password')"
                  :error-messages="
                    errors && errors.password ? errors.password : null
                  "
                  @input="removeError('password')"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="12">
            <v-textarea
              v-model="item.additional_info"
              :counter="3000"
              :rules="[rules.max(3000)]"
              rows="3"
              prepend-icon="mdi-account-badge-horizontal-outline"
              :label="
                lang($store, 'sap/listings.global.filter.hints.additional_info')
              "
              autocomplete="off"
              :error-messages="
                errors && errors.additional_info ? errors.additional_info : null
              "
              @change="updateRequest('additional_info', $event)"
              @input="removeError('additional_info')"
              :loading="isRequestingNow.includes('additional_info')"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row v-if="this.item.subscription_activity">
          <v-col
            cols="12"
            md="5"
            class="text-sm leading-5 text-gray-500 pesponsive-text mx-5"
          >
            <span>{{ $t('subscription.info') }}:</span>
            <p class="mr-2">
              {{ $t('subscription.last_time') }}
              <b v-if="managerName !== 'n/a'">{{ managerName }}</b> {{ $t('subscription.connect_about_sub') }}:
            </p>
            <v-menu
              v-model="menuFrom"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="fromDateFormatted"
                  @input="changeDate('contacted_at', $event)"
                  :label="lang($store, 'sap/listings.global.filter.hints.date')"
                  prepend-icon="mdi-calendar"
                  readonly
                  clearable
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateOfCall"
                no-title
                :first-day-of-week="1"
                :locale="getCurrentLocale()"
                @input="menuFrom = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="text-sm leading-5 text-gray-500 pesponsive-text mx-5">
            <span>{{ $t('subscription.managers_comment') }}:</span>
            <v-textarea
              v-model="commentOfCall"
              :counter="200"
              :rules="[rules.max(200)]"
              rows="3"
              autocomplete="off"
              :error-messages="
                errors && errors.additional_info ? errors.additional_info : null
              "
              @change="updateRequest('manager_note', $event)"
              @input="removeError('manager_note')"
              :loading="isRequestingNow.includes('manager_note')"
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <download-file-button
              :use-download-report-users="true"
              @click="onDownloadExcelHandler"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <h2 class="headline" style="position: relative">
              <v-icon>mdi-home-group</v-icon>
              <span>{{ lang($store, 'sap/listings.address.addresses') }}</span>
              <v-btn icon absolute right style="top: 0" @click="onAddAddress">
                <v-icon>mdi-home-plus</v-icon>
              </v-btn>
            </h2>
          </v-col>
          <v-col
            v-for="address in item.addresses"
            :key="address.uuid"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <v-card outlined class="v-sheet" style="height: 100%">
              <v-card-title>
                <v-icon large left>mdi-home-city-outline</v-icon>
                <span class="title font-weight-light">
                  {{
                    lang(
                      $store,
                      `sap/listings.global.filter.premises.${address.premises_type}`
                    )
                  }}
                </span>
                <v-spacer />
                <hoover v-if="hooverModeEnable() && address.is_hoover" />
                <v-spacer />
                <icon-tooltip
                  v-if="address.is_commerce"
                  icon="mdi-currency-usd"
                  text="Коммерция"
                  color="red"
                />
                <v-spacer />
                <v-btn icon @click="onAddressEdit(address)">
                  <v-icon>mdi-arrow-right-circle</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text class="headline font-weight-bold">{{
                address.formatted
              }}</v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- Promocodes -->
        <v-row>
          <v-col cols="12">
            <h2 class="headline" style="position: relative">
              <v-icon>mdi-qrcode-scan</v-icon>
              <span>{{ lang($store, 'sap/listings.global.promocodes') }}</span>
            </h2>
          </v-col>
          <v-col cols="12">
            <promocodes-simple-list :contact-uuid="item.uuid" />
          </v-col>
        </v-row>

        <!-- Discounts draggable -->
        <v-row class="my-8">
          <v-col cols="12" class="d-flex justify-space-between align-center">
            <h2 class="headline mr-4" style="position: relative">
              <v-icon>mdi-sale</v-icon>
              <span>{{ lang($store, 'sap/listings.global.discounts') }}</span>
            </h2>
            <div class="d-flex align-center">
              <v-text-field
                ref="discount"
                v-model="discountValue"
                type="number"
                :label="
                  lang($store, 'sap/listings.global.filter.hints.discount')
                "
                autocomplete="off"
                :rules="discountRules"
                max-width="50px"
                style="width: 140px"
              />
              <v-switch
                v-model="discountIsMoney"
                :label="
                  lang(
                    $store,
                    'sap/listings.global.filter.hints.discount_money'
                  )
                "
                :disabled="this.discountValue > 100"
              />
              <v-select
                width="200px"
                v-model="reason"
                :items="reasonItems"
                single-line
                :hint="
                  lang(
                    $store,
                    'sap/listings.global.filter.hints.discount_reason'
                  )
                "
                class="ml-8"
                persistent-hint
              ></v-select>
              <v-btn
                class="ml-8"
                @click="createDiscount"
                :disabled="
                  Number.isNaN(discountValue) || discountValue <= 0 || !reason
                "
              >
                {{ lang($store, 'sap/listings.global.add_discount') }}
              </v-btn>
            </div>
          </v-col>

          <draggable
            v-model="discountsCreated"
            group="discounts"
            class="list-group w-100 d-flex flex-wrap"
            handle=".handle"
            ghost-class="ghost"
            @change="onDragged"
          >
            <transition-group class="w-100 d-flex flex-wrap">
              <v-col
                cols="12"
                md="4"
                v-for="discount in discountsCreated"
                :key="discount.id"
                class="handle"
              >
                <discount-field
                  :value="discount.value"
                  @input="onChangeDiscountValue"
                  @onDelete="deleteDiscount"
                  has-delete
                />
              </v-col>
            </transition-group>
          </draggable>
        </v-row>

        <!-- Discounts used -->
        <v-row class="my-8" v-if="discountsDone.length">
          <v-col cols="12" class="d-flex justify-space-between align-center">
            <h2 class="headline mr-4" style="position: relative">
              <v-icon>mdi-sale</v-icon>
              <span>{{
                lang($store, 'sap/listings.global.discounts_used')
              }}</span>
            </h2>
          </v-col>
          <v-col
            cols="12"
            md="4"
            v-for="discount in discountsDone"
            :key="discount.id"
          >
            <v-card outlined class="pa-2 pt-1">
              <v-card-text class="d-flex justify-space-between">
                <div class="font-weight-bold body-1 black--text">
                  {{ discount.value }}
                  <span>{{ discount.is_money ? ' грн.' : '%' }}</span>
                  <span class="ml-2 subtitle-2">(
                    {{
                      lang(
                        $store,
                        `sap/listings.global.filter.discount_reasons.${discount.reason}`
                      )
                    }} )
                  </span>
                </div>
                <div class="font-weight-light blue--text">
                  {{ moment(discount.updated_at).format('DD.MM.YY HH:mm') }}
                </div>
              </v-card-text>
              <div class="px-3">{{ discount.note }}</div>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <h2 class="headline" style="position: relative">
              <v-icon>mdi-clipboard-list-outline</v-icon>
              <span>{{ lang($store, 'sap/listings.global.stat') }}</span>
            </h2>
          </v-col>
          <v-col cols="12">
            <contact-stats :data="stats" />
          </v-col>
        </v-row>
      </v-container>
    </v-flex>
    <!-- Edit Modal Address -->
    <edit-modal-address
      v-if="item"
      :contact="item"
      :item="currentEditableAddress"
      :is-show-dialog="isShowAddressDialog"
      :is-modal-loading="isLoadingAddressDialog"
      :action-label="addressDialogActionLabel"
      :errors="errorsAddressDialog"
      @on-close="onCloseAddressDialog"
      @on-action="onActionAddressDialog"
    />
  </v-container>
</template>

<script>
import debounce from 'debounce';
import draggable from 'vuedraggable';
import moment from 'moment';

import {
  REASONS,
  OTHER,
  DISCOUNT_DONE,
  DISCOUNT_CREATED
} from '@/constants/discount';

import validationMixin from '@/mixins/validationMixin';
import { prepareValidationMessages } from '@/utils';
import orderUpdateSimpleProp from '@/mixins/orders/orderUpdateSimpleProp';
import ContactProxy from '@/proxies/Contact/ContactProxy';
import StatsContactProxy from '@/proxies/Stats/StatsContactProxy';
import FieldPhoneWithNote from '@/components/text-fields/FieldPhoneWithNote.vue';
import EditModalAddress from '@/components/listings/EditModalAddress.vue';
import Hoover from '@/components/minialerts/IsHoover.vue';
import IconTooltip from '@/components/minialerts/IconTooltip.vue';
import PromocodesSimpleList from '@/components/domains/promocodes/PromocodesSimpleList.vue';
import DiscountField from '@/components/text-fields/DiscountField.vue';
import * as sources from '~constants/sources';
import addressDialog from '@/mixins/contacts/addressDialog';
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import ContactStats from '@/components/listings/ContactStats.vue';
import settingsMixin from '@/mixins/settingsMixin';
import DownloadFileButton from '@/components/minialerts/DownloadFileButton.vue';
import downloadReport from '@/mixins/reports/downloadReport';
import phoneMixin from "@/mixins/phoneMixin";

export default {
  name: 'ShowContact',
  mixins: [
    validationMixin,
    orderUpdateSimpleProp,
    addressDialog,
    updatePageContentMixin,
    settingsMixin,
    downloadReport,
    phoneMixin,
  ],
  components: {
    FieldPhoneWithNote,
    EditModalAddress,
    Hoover,
    IconTooltip,
    PromocodesSimpleList,
    DiscountField,
    DownloadFileButton,
    ContactStats,
    draggable
  },
  data() {
    return {
      moment,
      drag: false,
      showPass: false,
      pageLoading: false,
      isRequestingNow: [],
      item: null,
      discounts: [],
      reason: null,
      discountValue: 1,
      discountIsMoney: false,
      errors: {},
      menuFrom: false,
      commentOfCall: '',
      dateOfCall: '',
      managerName: '',
      stats: {},
      debounceUpdateDiscount: debounce(this.updateDiscount, 1500),
      discountsCreated: [],
      discountsDone: [],
      discountRules: [
        v => (!Number.isNaN(v) && v > 0) ||
          'Скидка должна быть положительным числом'
      ],
      reportMethodName: 'contactsLTVMetricsReport',
    };
  },
  created() {
    this.pageLoading = true;
    this.fetchStat();
    this.fetchData();
  },
  computed: {
    reasonItems() {
      return REASONS.map(value => ({
        text: this.lang(
          this.$store,
          `sap/listings.global.filter.discount_reasons.${value}`
        ),
        value
      }));
    },
    fromDateFormatted() {
      return this.formatDate(this.dateOfCall);
    },
    sourcesItems() {
      const items = [];
      Object.keys(sources).forEach(key => {
        items.push({
          text: this.lang(
            this.$store,
            `sap/listings.global.filter.sources.${sources[key]}`
          ),
          value: sources[key]
        });
      });
      return items;
    }
  },
  watch: {
    '$route.params.uuid': {
      handler() {
        this.fetchData();
      }
    },
    dateOfCall: {
      handler(newVal) {
        this.updateRequest('contacted_at', newVal);
      }
    }
  },
  methods: {
    getUpdateSimpleRequestClient() {
      return new ContactProxy();
    },
    fetchData() {
      new ContactProxy()
        .find(this.$route.params.uuid)
        .then(response => {
          this.item = response.data.data.contact;
          this.$route.meta.title = this.item.name;
          if (this.item.subscription_activity) {
            this.commentOfCall = this.item.subscription_activity.manager_note;
            this.dateOfCall = this.item.subscription_activity.contacted_at;
            this.managerName = this.item.subscription_activity.manager.name;
          }
          if (this.item.discounts && this.item.discounts.length) {
            this.discountsCreated = this.item.discounts
              .filter(discount => discount.status === DISCOUNT_CREATED)
              .map(discount => ({ id: discount.id, value: discount }));
            this.discountsDone = this.item.discounts.filter(
              discount => discount.status === DISCOUNT_DONE
            );
          }
        })
        .catch(error => {
          console.error(error);
          return this.$router.push({
            name: 404
          });
        })
        .finally(() => {
          this.pageLoading = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
    fetchStat() {
      new StatsContactProxy()
        .general(this.$route.params.uuid)
        .then(response => {
          this.stats = response.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    updateRequest(property, val) {
      if (!this.pageLoading) {
        this.isRequestingNow.push(property);
        this.updateSimpleRequest(
          this.item,
          property
        )(val)
          .catch(response => {
            this.errors = prepareValidationMessages(response.data.data);
          })
          .finally(() => {
            const index = this.isRequestingNow.indexOf(property);
            if (index !== -1) this.isRequestingNow.splice(index, 1);
          });
      }
    },
    onAddressEdit(address) {
      this.currentEditableAddress = address;
      this.isShowAddressDialog = true;
    },
    onAddAddress() {
      this.currentEditableAddress = {};
      this.isShowAddressDialog = true;
    },
    getContact() {
      return this.item;
    },
    changePassword($event) {
      if ($event) {
        this.updateRequest('password', $event);
        this.item.password = '';
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    changeDate(type, date) {
      if (date === null) {
        this.dateOfCall = '';
        this.updateRequest(type, '');
      }
    },
    onChangeDiscountValue(discountObj) {
      if (discountObj.reason === OTHER && !discountObj.note) {
        return;
      }
      if (!Number.isNaN(discountObj.value) && discountObj.value >= 0) {
        this.debounceUpdateDiscount(discountObj);
      }
    },
    createDiscount() {
      this.pageLoading = true;
      const api = new ContactProxy();

      api
        .createDiscount(this.$route.params.uuid, {
          value: this.discountValue,
          is_money: this.discountIsMoney,
          reason: this.reason,
          note: null
        })
        .then(discountData => {
          this.discountsCreated = [
            ...this.discountsCreated,
            { id: discountData.data.id, value: discountData.data }
          ];
          this.$store.dispatch('page/displaySnackbar', {
            text: 'Скидка добавлена',
            color: 'success',
            timeout: 3000
          });
        })
        .then(() => api.orderDiscount(this.$route.params.uuid, {
          ids: this.discountsCreated.map(discount => discount.id)
        }))
        .catch(error => {
          console.error(error);
          this.$store.dispatch('page/displaySnackbar', {
            text: 'Ошибка при создании дисконта',
            color: 'error',
            timeout: 3000
          });
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    updateDiscount(newDiscountObj) {
      this.pageLoading = true;
      new ContactProxy()
        .updateDiscount(this.$route.params.uuid, newDiscountObj)
        .catch(error => {
          console.error(error);
          this.$store.dispatch('page/displaySnackbar', {
            text: 'Ошибка при обновлении дисконта',
            color: 'error',
            timeout: 3000
          });
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    deleteDiscount(id) {
      this.pageLoading = true;
      new ContactProxy()
        .deleteDiscount(this.$route.params.uuid, { id })
        .then(() => {
          this.discountsCreated.splice(
            this.discountsCreated.findIndex(discount => discount.id === id)
          );
          this.$store.dispatch('page/displaySnackbar', {
            text: 'Дисконт удален',
            color: 'success',
            timeout: 3000
          });
        })
        .catch(error => {
          console.error(error);
          this.$store.dispatch('page/displaySnackbar', {
            text: 'Ошибка при удалении дисконта',
            color: 'error',
            timeout: 3000
          });
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    onDragged() {
      this.pageLoading = true;
      new ContactProxy()
        .orderDiscount(this.$route.params.uuid, {
          ids: this.discountsCreated.map(discount => discount.id)
        })
        .catch(error => {
          console.error(error);
          this.$store.dispatch('page/displaySnackbar', {
            text: 'Ошибка при сортировке дисконтов',
            color: 'error',
            timeout: 3000
          });
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    onDownloadExcelHandler() {
      this.searchParams = {};
      this.onDownloadExcel();
    },
    getCurrentLocale() {
      return window.localStorage.language;
    },
  }
};
</script>

<style scoped>
.pesponsive-text {
  border-radius: 4px;
  border: solid 1px #ccc;
  padding: 15px;
  position: relative;
  overflow: inherit;
}
.pesponsive-text p {
  height: auto;
  max-height: 300px;
  overflow-y: auto;
  width: 100%;
  word-break: break-word;
}
.pesponsive-text span {
  position: absolute;
  background-color: #fafafa;
  top: -14px;
  left: 20px;
  font-size: 12px;
  color: #aaa;
  padding: 5px;
}
.list-group {
  display: flex;
}
.ghost {
  border: 1px solid gray;
}
.handle {
  flex: 1 1 auto;
}
</style>
